import { format, subDays } from 'date-fns';
import { StringParam, useQueryParam, withDefault } from 'use-query-params';

export const DASHBOARD_DATE_FORMAT = 'yyyy-MM-dd';

// admin-dashboard-opdracht.md §4.0: "Vier standen: Vandaag / 7 dagen / 30 dagen / 90 dagen, plus
// een eigen bereik. De gekozen stand hoort in de URL." Band 1/4 never use from/to (always "now" -
// see AdminDashboardFacadeImpl's own javadoc on why); this hook only feeds the period-dependent
// bands (1b, 2's trend/source charts, 3). Default changed 30 -> 7 days, 2026-08-25 (Danny) -
// the opdracht's original "Standaard 30 dagen" no longer applies.
export type DashboardPeriodPreset = '1' | '7' | '30' | '90' | 'custom';

const PRESET_DAYS: Record<Exclude<DashboardPeriodPreset, 'custom'>, number> = { '1': 1, '7': 7, '30': 30, '90': 90 };

export function useDashboardPeriod() {
  const today = format(new Date(), DASHBOARD_DATE_FORMAT);

  const [preset, setPreset] = useQueryParam('period', withDefault(StringParam, '7'));
  const [from, setFrom] = useQueryParam(
    'from',
    withDefault(StringParam, format(subDays(new Date(), PRESET_DAYS['7'] - 1), DASHBOARD_DATE_FORMAT))
  );
  const [to, setTo] = useQueryParam('to', withDefault(StringParam, today));

  const selectPreset = (next: DashboardPeriodPreset) => {
    setPreset(next);
    if (next !== 'custom') {
      setFrom(format(subDays(new Date(), PRESET_DAYS[next] - 1), DASHBOARD_DATE_FORMAT));
      setTo(today);
    }
  };

  return {
    preset: preset as DashboardPeriodPreset,
    from: from as string,
    to: to as string,
    setFrom,
    setTo,
    selectPreset,
    isToday: preset === '1',
    today,
  };
}
